export default __webpack_public_path__ + "static/media/photo_5282747746622312913_y.d165217f.jpg";